import React, { useRef, useState } from 'react';
import ImageUpload from '../Cloudinary/ImageUpload';
import axios from 'axios';

const AddProductForm = ({editProduct}) => {
  const [uploadedImageUrl, setUploadedImageUrl] = useState([]);
  const [isButtonDisabled,setButtonDisabed]=useState(false);
  const formref=useRef();
  const handleImageUpload = (imageUrl) => {
    if (imageUrl) {
      if(uploadedImageUrl.length>=6){
        alert("No More Images can be accepted");
        return;
      }
      setUploadedImageUrl((prevImages) => {
        if (prevImages.length === 0) {
          return [imageUrl];
        } else {
          return [...prevImages, imageUrl];
        }
      });
    } else {
      alert("No Image URL found");
    }
  };



  const Workup=async (event)=>{
    event.preventDefault();
    setButtonDisabed(!isButtonDisabled);
    const data ={
      name : event.target[0].value,
      description: event.target[1].value,
      price :event.target[2].value,
      delivery : event.target[3].value,
      category : event.target[4].value,
      images : uploadedImageUrl
    }
    console.log(data);
    await axios.post(`${process.env.REACT_APP_BASE}/product/new`,data).then((response)=>{
      console.log(response);
      setButtonDisabed(!isButtonDisabled);
      setUploadedImageUrl([]);
      editProduct(data);
      formref.current.reset();
      return;
    }).catch((err)=>{
      console.log(err);
      return;
    })
  }

  const resetimages=()=>{
    setUploadedImageUrl([]);
      return ;
  }
  return (
    <div className='rounded-md bg-gray-300 shadow-lg border bg-black w-1/1 md:w-1/2 lg:w-2/5 xl:w-2/5 '>
      
      <form ref={formref} className="p-4 grid grid-rows-7 rounded shadow-lg gap-4 flex items-center justify-center " onSubmit={Workup}>
        <h1 className='text-lg font-bold'>Add Product</h1>
        <input name="title" className=" rounded-full text-center" placeholder='Title Of Product' required/>
        <input name="description" className=" rounded-full text-center" placeholder='Description Of Product' required/>
        <input name="Price" className=" rounded-full text-center" placeholder='Price Of Product' type="number" required/>
        <input name="Delivery" className=" rounded-full text-center" placeholder='Delivery Time' type="number" required/>
        <select name="Category" class=" rounded-full text-center" defaultValue={"NA"} required>
            <option value="" disabled selected >Select Category</option>
            <option value="men">Men</option>
            <option value="women">Women</option>
            <option value="kids">Kids</option>
        </select>

        <ImageUpload setter={handleImageUpload}/>
        <div>
          <h2>Images</h2>
          {
            uploadedImageUrl.length? 
            <div className='grid grid-cols-2 grid-rows-2 border'>
              {
                uploadedImageUrl.map((item)=>{
                  return (<img src={item} alt="product" height="200px" width="200px"/>)
                })
              }
          </div> 
          :
          <div>
              No Images Added
          </div>
          }
        </div>
       <div className='grid grid-cols-2'>
          <button className='bg-green-500 rounded-full px-3 py-1 text-sm font-semibold text-white mr-2 mb-2 hover:bg-green-700 cursor:pointer' disabled={isButtonDisabled}> Submit</button>
          <button className='bg-gray-500 rounded-full px-3 py-1 text-sm font-semibold text-white mr-2 mb-2 hover:bg-gray-700 cursor:pointer' type="reset" onClick={resetimages}> Reset</button>
       </div>

      </form>
      
    </div>
  );
};

export default AddProductForm;
